import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { Mic2 } from "lucide-react";
import { RECITERS } from "@/data/reciters";

/**
 * Compact reciter picker for the Reader header — gives users one-tap access
 * to switch qari without digging into the audio-bar settings panel.
 */
export default function ReciterPicker({ value, onChange, className = "" }) {
  return (
    <div className={`flex items-center ${className}`}>
      <Select value={value} onValueChange={onChange}>
        <SelectTrigger
          data-testid="reciter-picker"
          className="h-8 bg-islamic-blue-900/50 border-white/10 text-slate-200 text-xs px-2 gap-1 w-auto"
          title="Choose reciter"
        >
          <Mic2 className="w-3.5 h-3.5 text-gold-400 shrink-0" />
          <SelectValue>
            <span className="hidden sm:inline">
              {RECITERS.find((r) => r.value === value)?.label?.split(" ").slice(0, 2).join(" ") || "Reciter"}
            </span>
          </SelectValue>
        </SelectTrigger>
        <SelectContent className="bg-islamic-blue-900 border-white/10 max-h-72">
          {RECITERS.map((r) => (
            <SelectItem
              key={r.value}
              value={r.value}
              className="text-slate-200 text-sm"
              data-testid={`reciter-option-${r.value}`}
            >
              {r.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
